<template>
  <el-dialog
    :title="form.id ? '编辑课程分类' : '新建课程分类'"
    :visible.sync="formVisible"
    width="600px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="dataForm"
      :rules="formRules"
      :model="form"
      label-position="right"
      size="small"
      label-width="120px"
    >
      <el-form-item label="上级分类">
        <treeselect
          v-model="form.parentId"
          :options="menuOptions"
          :normalizer="normalizer"
          :show-count="true"
          noOptionsText="暂无数据"
          placeholder="请选择"
          @select="handleSelect"
        />
        <span>不选择上级分类，默认为1级分类</span>
      </el-form-item>
      <el-form-item label="分类名称" prop="typeName">
        <el-input v-model="form.typeName" placeholder="请输入分类名称" />
      </el-form-item>
      <el-form-item label="分类类别" prop="categoryId">
        <!--  1新用户福利 2课程 3直播 4疾病科普 5皮科普药 -->
        <el-select
          v-model="form.categoryId"
          placeholder="请选择"
          clearable
          size="small"
        >
          <el-option label="新用户福利" :value="1"></el-option>
          <el-option label="课程" :value="2"></el-option>
          <el-option label="直播" :value="3"></el-option>
          <el-option label="疾病科普" :value="4"></el-option>
          <el-option label="皮科普药" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="背景图片" prop="bgImage">
        <imageUpload v-model="form.bgImage" width="50" height="50" />
      </el-form-item>
      <el-form-item label="页面排序">
        <el-input v-model="form.orderNo" placeholder="请输入页面排序" />
        <!-- <span>系统自动带出排序，并支持修改</span> -->
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          v-model="form.described"
          placeholder="请输入描述"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch
          v-model="form.state"
          :active-value="1"
          :inactive-value="0"
        ></el-switch
        >{{ form.state ? "启用" : "禁用" }}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import courseClassificationApi from "@/api/course/courseClassification";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    parentId: null,
    typeName: null,
    orderNo: null,
    described: null,
    categoryId: null,
    bgImage: null,
    state: 0
  };
  return formBean;
}

export default {
  props: ["menuOptions"],
  components: { ImageUpload, Treeselect },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        typeName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ],
        categoryId: [
          { required: true, message: "请选择分类类别", trigger: "change" }
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      isRepSub: false
    };
  },
  created() {},
  methods: {
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (
        (node.classificationChildList &&
          !node.classificationChildList.length) ||
        node.levelType === 2
      ) {
        delete node.classificationChildList;
      }
      return {
        id: node.id,
        label: node.typeName,
        children: node.classificationChildList
      };
    },
    handleSelect(node) {
      if (node && node.levelType) {
        this.form.levelType = node.levelType + 1;
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean();
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm();
      this.form.levelType = row.levelType ? row.levelType + 1 : 1;
      console.log(this.form);
      this.form.parentId = row.id ? row.id : null;
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = { ...row };
      this.$set(this.form, "parentId", row.parentId ? row.parentId : null);
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.orderNo = params.orderNo || 0;
      params.parentId = params.parentId || 0;
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if (this.isRepSub) return;
          this.isRepSub = true;
          if (this.form.id > 0) {
            courseClassificationApi
              .update(params)
              .then(data => {
                this.postCallback(data);
              })
              .catch(res => {
                this.isRepSub = false;
              });
          } else {
            courseClassificationApi
              .create(params)
              .then(data => {
                this.postCallback(data);
              })
              .catch(res => {
                this.isRepSub = false;
              });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
